export enum GeoDrawTypeEnum {
  polygon = 'polygon',
  circle = 'circle',
}
